"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Mon Jun 11 2018
 */

var typescript_ioc_1 = require("@logio/typescript-ioc");

var index_1 = require("../../core/utils/index");

var Family_1 = require("../model/Family");

var FamilyBindingConverter_1 = require("./FamilyBindingConverter");

var FamilyConverter_1 = require("./FamilyConverter");
/**
 * Default implementation of FamilyConverter.
 *
 * @author JMe
 */


var FamilyConverterImpl =
/*#__PURE__*/
function (_FamilyConverter_1$Fa) {
  _inherits(FamilyConverterImpl, _FamilyConverter_1$Fa);

  function FamilyConverterImpl(familyBindingConverter) {
    var _this;

    _classCallCheck(this, FamilyConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FamilyConverterImpl).call(this));
    _this.familyBindingConverter = familyBindingConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(FamilyConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new Family_1.Family(Family_1.Family.schema.id.valueOf(conversions.documentToClassId(source)), Family_1.Family.schema.numericId.valueOfField(source), Family_1.Family.schema.name.valueOfField(source), Family_1.Family.schema.tierId.valueOf(conversions.toClassReferenceId(source.tierId)), conversions.asObjectList(source, 'bindings', this.deserializeBindings(conversions)));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        name: source.name,
        tierId: conversions.toDocumentReferenceId(source.tierId),
        bindings: conversions.asObjectArray(source, 'bindings', this.serializeBindings(conversions))
      });

      if (source.numericId !== index_1.Utils.VOID_NUMERIC_ID) {
        // FIXME JGr LOG-1622
        // This function is used to convert data from user to json which is consequently persisted.
        // Numeric ID cannot be changed during update and we don't want to load current value from DB.
        // So if we are processing update then we replace value from user by VOID. Here we are able
        // to recognize this situation and ignore the value.
        Object.assign(result, {
          numericId: source.numericId
        });
      }

      return result;
    }
  }, {
    key: "deserializeBindings",
    value: function deserializeBindings(conversions) {
      var _this2 = this;

      return function (document) {
        return _this2.familyBindingConverter.toObject(document, conversions);
      };
    }
  }, {
    key: "serializeBindings",
    value: function serializeBindings(conversions) {
      var _this3 = this;

      return function (object) {
        return _this3.familyBindingConverter.toDocument(object, conversions);
      };
    }
  }]);

  return FamilyConverterImpl;
}(FamilyConverter_1.FamilyConverter);

FamilyConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [FamilyBindingConverter_1.FamilyBindingConverter])], FamilyConverterImpl);
exports.FamilyConverterImpl = FamilyConverterImpl;